import {
    GET_ERRORS
} from './type';
import SellerUser from '../Models/SellerUser';
import BuyerUser from '../Models/BuyerUser';
import AffiliatorUser from '../Models/AffiliatorUser';
export const affiliatorRegisterForm = (affiliatorData, history) => dispatch => {
    AffiliatorUser.createResgistration2(affiliatorData)
        .then(res => {
            if (parseInt(res.data.status) === 200) {
                window.localStorage.setItem('success', JSON.stringify(res.data.status));
                history.push('/login/affiliator');
            } else {
                dispatch({
                    type: GET_ERRORS,
                    payload: res.data.message
                })
            }
        })
        .catch(console.log('error'))
};

export const buyerRegister = (buyerData, history) => dispatch => {
    BuyerUser.createResgistration1(buyerData)
        .then(res => {
            if (parseInt(res.data.status) === 200) {
                window.localStorage.setItem('errors', '');
                window.localStorage.setItem('email', JSON.stringify(res.data.email));
                history.push('/Buyer-registration-step-2');
            } else {
                dispatch({
                    type: GET_ERRORS,
                    payload: 'メールアドレスはすでに存在します'
                })
            }
        })
        .catch()
};
export const buyerRegisterForm = (buyerData, history) => dispatch => {
    BuyerUser.createResgistration2(buyerData)
        .then(res => {
            if (parseInt(res.data.status) === 200) {
                history.push('/step-1-confirmation');
            } else {
                dispatch({
                    type: GET_ERRORS,
                    payload: res.data.message
                })
            }
        })
        .catch(console.log('error'))
};
export const sellerRegister = (data, history) => dispatch => {
    SellerUser.createResgistration1(data)
        .then(res => {
            if (parseInt(res.data.status) === 200) {
                window.localStorage.setItem('errors', '');
                window.localStorage.setItem('email', JSON.stringify(res.data.email));
                history.push('/seller-registration-step-2');
            } else {
                dispatch({
                    type: GET_ERRORS,
                    payload: 'メールアドレスはすでに存在します'
                })
            }

        })
        .catch(

        )
};
export const sellerRegisterForm = (data, history) => dispatch => {
    SellerUser.createResgistration2(data)
        .then(res => {
            if (parseInt(res.data.status) === 200) {
                history.push('/step-1-confirmation');
            } else {
                dispatch({
                    type: GET_ERRORS,
                    payload: res.data.message
                })
            }


        })
        .catch(console.log('error'))
};